import clsx from 'clsx';
import * as React from 'react';

import { diff } from '@gitbook/doc-core';

import {
    DocumentNodeCommentButton,
    type RightGutterComponentType,
    useDocumentNodeComments,
} from '../../../../Components';
import { shortcuts, useKeyboardShortcuts } from '../../../../Keyboard';

/**
 * Button to comment a node.
 */
export const BlockCommentButton = React.memo(function BlockCommentButton(
    props: React.ComponentProps<RightGutterComponentType>
) {
    const { className, nodeKey: rawNodeKey, visible, style, shortcutsActive } = props;

    const nodeKey = diff.getOriginalDiffKey(rawNodeKey);

    const { hasComments, numberOfComments, onPressOpenNodeComment, onPressNewComment } =
        useDocumentNodeComments({
            nodeKey,
        });

    const onPress = () => {
        return hasComments ? onPressOpenNodeComment() : onPressNewComment();
    };

    // Bind the shortcut to open this palette.
    useKeyboardShortcuts(
        shortcutsActive
            ? {
                  [shortcuts.EDITOR_COMMENT]: onPress,
              }
            : {},
        ['editor-selection-collapsed', 'editor-selection-expanded']
    );

    return (
        <div
            className={clsx(
                'flex min-w-fit items-start justify-start gap-1 transition max-md:hidden',
                className,
                visible || hasComments
                    ? 'opacity-100'
                    : 'opacity-0 hover:opacity-100 group-hover/gutter:opacity-100'
            )}
            style={style}
            data-hide-on-drag
        >
            <DocumentNodeCommentButton
                hasComments={hasComments}
                numberOfComments={numberOfComments}
                onPress={onPress}
                onPressNewComment={onPressNewComment}
            />
        </div>
    );
});
